import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Index from './pages';
import About from "./pages/about";
import Contact from "./pages/contact";
import Services from "./pages/services";
import FrontEnd from "./component/Layout/Frontend/FrontEnd";
import Error from "./pages/error.js";
import Blog from "./pages/blog.js";
import Gallery from "./pages/gallery.js";
import Career from "./pages/career.js";
// import OmniSupport from './pages/services/omni_support.js';
import VirtualLearning from "./pages/services/virtual_learning.js";
import AccountingAndBookkeepingServices from "./pages/services/accounting_and_bookkeeping_services.js";
import DataManagement from "./pages/services/data_management.js";
import WebsiteDesignDevelopment from "./pages/services/website-design_development.js";
import ContentWriting from "./pages/services/content_writing.js";
import E_CommerceServices from "./pages/services/e-commerce_services.js";
// import VoiceSupport from './pages/services/voice_support.js';
import DigitalMarketing from "./pages/services/digital_marketing.js";
import MobileAppDevelopment from "./pages/services/mobile_app_development.js";
import How_digital_marketing_is_different_from_traditional_marketing from "./pages/blog/how_digital_marketing_is_different_from_traditional_marketing.js";
import How_digital_marketing_helps_in_business_growth from "./pages/blog/how_digital_marketing_helps_in_business_growth.js";
import Top_digital_marketing_strategies_for_gym from "./pages/blog/top_digital_marketing_strategies_for_gym.js";
import Top_10_digital_marketing_strategies_for_the_startups from "./pages/blog/top_10_digital_marketing_strategies_for_the_startups.js";
import Top_digital_marketing_strategies_for_the_product_launch from "./pages/blog/top_digital_marketing_strategies_for_the_product_launch.js";
import How_does_digital_marketing_help_small_businesses from "./pages/blog/how_does_digital_marketing_help_small_businesses.js";
import PrivacyPolicy from "./pages/policy/privacy_policy.js";
import CancellationPolicy from "./pages/policy/cancellation_policy.js";
import TermsConditions from "./pages/policy/terms_conditions.js";
import DigitalMarketingPricing from "./pages/digital_marketing_pricing.js";
import ScrollTopButton from "./component/ScrollTopButton.js";
import Test from "./pages/test.js";
import ScrollToTop from "./component/ScrollToTop.js";
import SEO from "./pages/services/seo.js";
import Client_testimonial from "./pages/client_testimonial.js";
import PHPWebDevelopmentService from "./pages/services/php_web_development_service.js";
import NodeJsDevelopmentService from "./pages/services/nodejs_development_services.js";
import AngularDevelopment from "./pages/services/angular_development.js";
import DigitalMarketingStrategyDevelopment from "./pages/services/digital_marketing_strategy_development.js";
import FranchiseDigitalMarketing from "./pages/services/franchise_digital_marketing.js";
import SEOConsultant from "./pages/services/seo-consultant.js";
import EcommerceSEO from "./pages/services/ecommerce_seo.js";
import FullStackDevelopmentService from "./pages/services/full_stack_development_service.js";
import LaravelDevelopment from "./pages/services/laravel_development.js";
import SocialMediaMarketing from "./pages/services/social_media_marketing.js";
import PPCMarketing from "./pages/services/ppc_marketing.js";
import TechnicalSeoService from "./pages/services/Technical_seo_service.js";
import LocalSeoService from "./pages/services/local_seo.js";
import SeoAudit from "./pages/services/seo_audit.js";
import SeoContentWriting from "./pages/services/seo_content_writing.js";
import What_is_web_development_a_simple_guide_for_beginners from "./pages/blog/what_is_web_development.js";
import Frontend_vs_backend_whats_the_difference_and_why_it_matters from "./pages/blog/frontend_vs_backend_whats_the_difference_and_why_it_matters.js";
import IosAppDevelopmentServices from "./pages/services/ios_app_development_services.js";
import AndroidAppDevelopmentServices from "./pages/services/android_app_development.js";
import FlutterAppDevelopmentCompany from "./pages/services/flutter_app_development_company.js";
import MagentoDevelopmentServices from "./pages/services/magento_development_services.js";
import ShopifyDevelopmentServices from "./pages/services/shopify_development_services.js";
import WooCommerceDevelopment from "./pages/services/woo_commerce_development.js";
import VirtualAssistantService from "./pages/services/virtual_learning_services.js";
import ErpSoftwareDevelopmentServices from "./pages/services/erp_software_development_services.js";
import How_to_choose_the_right_technology_for_your_website from "./pages/blog/how_to_choose_the_right_technology_for_your_website.js";
import Why_does_a_custom_website_design_beats_a_ready_made_template  from "./pages/blog/why_does_a_custom_website_design_beats_a_ready-made_template.js"
import What_is_digital_marketing_and_why_does_your_business_need_it from "./pages/blog/what_is_digital_marketing_and_why_does_your_business_need_it.js";


function App() {
  return (
    <div className="App">
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<FrontEnd />}>
            {/* <Route path='/' element={<Index />} /> */}
            <Route path="/" element={<Test />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            {/* <Route path='/omni-support' element={<OmniSupport />} /> */}
            <Route
              path="/virtual-assistant-service"
              element={<VirtualAssistantService />}
            />
            <Route
              path="/accounting-bookkeeping-services"
              element={<AccountingAndBookkeepingServices />}
            />
            <Route
              path="/data-management-services"
              element={<DataManagement />}
            />
            <Route
              path="/website-design-development"
              element={<WebsiteDesignDevelopment />}
            />

            {/* Web Development Sub Services Start  */}
            <Route
              path="/php-web-development-agency"
              element={<PHPWebDevelopmentService />}
            />
            <Route
              path="/node-js-development-service"
              element={<NodeJsDevelopmentService />}
            />
            <Route
              path="/angular-development-service"
              element={<AngularDevelopment />}
            />
            <Route
              path="/full-stack-development-service"
              element={<FullStackDevelopmentService />}
            />
            <Route
              path="/laravel-development-service"
              element={<LaravelDevelopment />}
            />
            {/* Web Development Sub Service End  */}

            <Route
              path="/content-writing-service"
              element={<ContentWriting />}
            />
            <Route
              path="/e-commerce-services"
              element={<E_CommerceServices />}
            />
            <Route
              path="/digital-marketing-services"
              element={<DigitalMarketing />}
            />
            {/* Digital Marketing Sub Service Start  */}
            <Route
              path="/digital-marketing-strategy-development"
              element={<DigitalMarketingStrategyDevelopment />}
            />
            <Route
              path="/franchise-digital-marketing-service"
              element={<FranchiseDigitalMarketing />}
            />
            <Route
              path="/social-media-marketing-service"
              element={<SocialMediaMarketing />}
            />
            <Route
              path="/pay-per-click-marketing-service"
              element={<PPCMarketing />}
            />
            {/* Digital Marketing Sub Service End  */}
            {/* Mobile App Start */}
            <Route
              path="/mobile-app-development"
              element={<MobileAppDevelopment />}
            />
            <Route
              path="/ios-app-development-services"
              element={<IosAppDevelopmentServices />}
            />
            <Route
              path="/android-app-development-services"
              element={<AndroidAppDevelopmentServices />}
            />
            <Route
              path="/flutter-app-development-company"
              element={<FlutterAppDevelopmentCompany />}
            />
            <Route
              path="/magento-development-services"
              element={<MagentoDevelopmentServices />}
            />
            <Route
              path="/shopify-development-services"
              element={<ShopifyDevelopmentServices />}
            />
            <Route
              path="/woo-commerce-development-services"
              element={<WooCommerceDevelopment />}
            />
            {/* Mobile App End */}
            <Route path="/search-engine-optimzation" element={<SEO />} />
            {/* SEO sub service start  */}
            <Route path="/seo-consultant-service" element={<SEOConsultant />} />
            <Route path="/ecommerce-seo-service" element={<EcommerceSEO />} />

            <Route path="/technical-seo-service" element={<TechnicalSeoService />} />
            <Route path="/local-seo-service" element={<LocalSeoService />} />
            <Route path="/seo-audit-service" element={<SeoAudit />} />
            <Route path="/seo-content-writing-service" element={<SeoContentWriting />} />
            {/* SEO sub service End  */}
            <Route path="/erp-software-development-services" element={<ErpSoftwareDevelopmentServices />} />
            {/* blogs start */}
            <Route path="/blog" element={<Blog />} />
            <Route
              path="/how-digital-marketing-is-different-from-traditional-marketing"
              element={
                <How_digital_marketing_is_different_from_traditional_marketing />
              }
            />
            <Route
              path="/how-digital-marketing-helps-in-business-growth"
              element={<How_digital_marketing_helps_in_business_growth />}
            />
            <Route
              path="/top-digital-marketing-strategies-for-gym"
              element={<Top_digital_marketing_strategies_for_gym />}
            />
            <Route
              path="/top-10-digital-marketing-strategies-for-the-startups"
              element={<Top_10_digital_marketing_strategies_for_the_startups />}
            />
            <Route
              path="/top-digital-marketing-strategies-for-the-product-launch"
              element={
                <Top_digital_marketing_strategies_for_the_product_launch />
              }
            />
            <Route
              path="/how-does-digital-marketing-help-small-businesses"
              element={<How_does_digital_marketing_help_small_businesses />}
            />
            <Route
              path="/what-is-web-development-a-simple-guide-for-beginners"
              element={<What_is_web_development_a_simple_guide_for_beginners />}
            />
            <Route 
              path="/frontend-vs-backend-whats-the-difference-and-why-it-matters"
              element={<Frontend_vs_backend_whats_the_difference_and_why_it_matters />}
            />
            <Route
            path="/how-to-choose-the-right-technology-for-your-website"
            element={<How_to_choose_the_right_technology_for_your_website />}
            />
             <Route
            path="/why-does-a-custom-website-design-beats-a-ready-made-template"
            element={<Why_does_a_custom_website_design_beats_a_ready_made_template />}
            />
            <Route 
            path="/what-is-digital-marketing-and-why-does-your-business-need-it"
            element={<What_is_digital_marketing_and_why_does_your_business_need_it />}
            />
            {/* blogs end */}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/career" element={<Career />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/cancellation-policy"
              element={<CancellationPolicy />}
            />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route
              path="/digital-marketing-pricing"
              element={<DigitalMarketingPricing />}
            />
            <Route
              path="/client-testimonial"
              element={<Client_testimonial />}
            />
            <Route path="*" element={<Error />} />
          </Route>
        </Routes>
      </Router>
      <ScrollTopButton />
    </div>
  );
}

export default App;
